<template>
<div>
  <div v-if="cartItems.length" class="wph-order-summary">
    <div class="wph-flex wph-items-baseline wph-flex-wrap">
      <h2 class="wph-mb-6 wph-mr-4 wph-text-xl wph-text-accent-dark">Ваш заказ</h2>
      <button role="button" @click="$emit('go-to-editor')"
              class="wph-button wph-button--secondary wph-button--small wph-font-normal wph-text-sm"
      >Добавить еще товар</button>
    </div>
    <div class="wph-order-summary__row wph-hidden lg:wph-flex wph-font-bold wph-text-sm wph-text-gray-500 wph-bg-blue-lightest">
      <div class="wph-order-summary__cell wph-order-summary__cell--number">#</div>
      <div class="wph-order-summary__cell wph-order-summary__cell--model">Модель</div>
      <div class="wph-order-summary__cell wph-order-summary__cell--print">Нанесение</div>
      <div class="wph-order-summary__cell wph-order-summary__cell--prices lg:wph-text-right">Стоимость</div>
      <div class="wph-order-summary__cell wph-order-summary__cell--actions"></div>
    </div>
    <cart-item v-for="(item, index) in cartItemsWithModels" :key="item.virtualId"
              :cart-item="item"
              v-slot="{
                              cartItem,

                              isBag,
                              number,
                              prices,
                              resultPrice,
                              totals,
                              total,
                              totalPerItem,
                            }"
    >
      <div class="wph-order-summary__row" v-if="cartItem.model">
        <div class="wph-order-summary__cell wph-order-summary__cell--number wph-hidden lg:wph-block">{{ index + 1 }}</div>
        <div class="wph-order-summary__cell wph-order-summary__cell--model">
          <div class="lg:wph-hidden wph-text-gray-500 wph-text-sm wph-mb-1">#{{ index + 1 }}</div>
          <span class="wph-order-summary__cell-label">Модель</span>
          <h3 class="wph-mb-1 wph-text-xl wph-text-accent-dark">{{ cartItem.model.title }}
            <span v-if="isBag">, {{ cartItem.density.label }}</span>
          </h3>
          <span>
            <span class="wph-inline-block wph-w-3 wph-h-3 wph-mr-1 wph-rounded-full"
                  :style="{
                    backgroundColor: cartItem.color.hex,
                  }"
            ></span>
            <span class="wph-text-gray-500 wph-lowercase">{{ cartItem.color.label }}</span>
          </span>
          <template v-if="!isBag">
            <span class="wph-font-bold wph-pl-8">{{ cartItem.number }}</span>
            <span class="wph-text-gray-500"> шт.</span>
            <span class="wph-px-2 wph-text-gray-500">&times;</span>
            <span class="wph-font-bold">{{ resultPrice | money }}</span>
            <span v-if="resultPrice < prices.max" class="wph-text-xs wph-line-through wph-inline-block wph-ml-1 wph-text-gray-500">{{ prices.max | money }}</span>
          </template>
          <template v-else>
            <div v-for="size in cartItem.sizes" :key="size.data.id">
              <span class="wph-text-gray-500">{{ size.data.label }} - </span>
              <span class="wph-font-bold">{{ size.number }}</span>
              <span class="wph-text-gray-500"> шт.</span>
            </div>
          </template>
        </div>
        <div class="wph-order-summary__cell wph-order-summary__cell--print">
          <span class="wph-order-summary__cell-label">Нанесение</span>
          <template v-if="cartItem.printLocations.length">
            <!--TODO: Удалить проп textile-color (перенесен в стратегии определения стоимости печати)-->
            <print-location v-for="location in cartItem.printLocations" :key="location.data.id"
                            :product="cartItem"
                            :location="location"
                            :number="number"
                            :textile-color="cartItem.color"
                            v-slot="{ location, totalSelectedColorsNumber }"
            >
              <p class="wph-mb-1 wph-leading-tight">
                <span class="wph-font-bold wph-text-accent-dark">{{ location.data.name }}:</span>
                {{ location.technology.label }} <span v-if="location.metallizedThread">металлизированной нитью</span>
                <span class="wph-whitespace-no-wrap"> {{ location.square.id === 'custom' || location.square.id === 'bagCustom' ? `${location.w}×${location.h} ${location.square.units}` : location.square.label }}</span><span v-if="location.technology.allowsColorPick">,</span>
                <span v-if="location.technology.allowsColorPick">
                  {{ totalSelectedColorsNumber }}
                  {{ totalSelectedColorsNumber | plural('цвет', 'цвета', 'цветов') }}
                </span>
              </p>
            </print-location>
          </template>
          <template v-else>
            <p class="wph-text-gray-500">Без нанесения</p>
          </template>
        </div>
        <div class="wph-order-summary__cell wph-order-summary__cell--prices lg:wph-text-right">
          <span class="wph-order-summary__cell-label">Стоимость</span>
          <div v-if="!isBag" class="wph-mb-3">
            <p class="wph-mb-1 wph-leading-tight">
              <span class="wph-text-gray-500">Тираж: </span>
              <span class="wph-text-accent-dark">{{ totals.current | money }}</span>
              <span v-show="totals.current < totals.max"
                    class="wph-text-xs wph-line-through wph-inline-block wph-ml-1 wph-text-gray-500"
              > {{ totals.max | money }}</span>
            </p>
            <p v-if="cartItem.printLocations.length" class="wph-mb-1 wph-leading-tight">
              <span class="wph-text-gray-500">Нанесение: </span>
              <span class="wph-text-accent-dark">{{ totals.print | money }}</span>
            </p>
            <p class="wph-mb-1 wph-leading-tight">
              <span class="wph-text-gray-500">Упаковка: </span>
              <span class="wph-text-accent-dark">{{ totals.packing | money }}</span>
            </p>
          </div>
          <p class="wph-pt-1 wph-leading-tight">
            <span class="wph-text-gray-500">Всего: </span>
            <span class="wph-font-bold wph-text-accent-dark">{{ total | money }}</span>
          </p>
          <p class="wph-text-sm wph-text-gray-500">{{ totalPerItem | money }} за шт.</p>
        </div>
        <div class="wph-order-summary__cell wph-order-summary__cell--actions wph-pr-1">
          <div class="wph-flex wph-items-center">
            <button role="button" @click="goToEditor(cartItem)"
                    class="wph-mr-2" title="Редактировать"
            >
              <img :src="`${publicPath}img/edit.png`" width="26" class="wph-h-auto">
            </button>
            <button role="button" @click="removeCartItemById(cartItem.virtualId)"
                    class="wph-px-2 wph-text-red-dark wph-font-bold" title="Удалить"
            >&times;</button>
          </div>
        </div>
      </div>
    </cart-item>

    <div class="wph-my-4">
      <p class="wph-mb-2">* Срок производства тиража: от 7 дней</p>
      <div class="wph-flex wph-items-baseline">
        <p>
          <app-checkbox v-model="orderIsUrgent">Срочный заказ</app-checkbox>
        </p>
        <div class="wph-w-64 wph-max-w-full wph-ml-4" :class="{ 'wph-invisible': !orderIsUrgent }">
          <multiselect :options="orderUrgencyRates" v-model="orderUrgencyRate"
                      :searchable="false"
                      label="label"
                      placeholder="Укажите срок"
                      deselectLabel=""
          ></multiselect>
        </div>
      </div>
      <p v-show="orderIsUrgent" class="wph-mt-1 wph-text-xs">* В выходные и праздниные дни +{{ cartHasBags ? '300' : '200' }}%</p>

    </div>
  </div>
  <div v-else class="wph-text-center">
    <div class="wph-flex wph-justify-center wph-items-stretch wph-w-48 wph-h-48 wph-p-8 wph-mx-auto wph-bg-red-lighter wph-rounded-full">
      <svg class="wph-w-full wph-fill-current wph-text-red-darker wph-opacity-50" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;" viewBox="0 0 100 88.1105" x="0px" y="0px" fill-rule="evenodd" clip-rule="evenodd"><g><path class="fil0" d="M1.34184 33.9313l13.2082 0 25.9515 -29.8537c-0.05844,-0.245904 -0.089178,-0.502432 -0.089178,-0.766172 0,-1.82872 1.48263,-3.31135 3.31135,-3.31135 1.82872,0 3.31135,1.48263 3.31135,3.31135 0,1.82872 -1.48263,3.31135 -3.31135,3.31135 -0.332425,0 -0.653466,-0.0493325 -0.956291,-0.140408l-23.861 27.449 62.4561 0 -23.861 -27.449c-0.302826,0.0914549 -0.623866,0.140408 -0.956291,0.140408 -1.82872,0 -3.31135,-1.48263 -3.31135,-3.31135 0,-1.82872 1.48263,-3.31135 3.31135,-3.31135 1.82872,0 3.31135,1.48263 3.31135,3.31135 0,0.263739 -0.0311174,0.520268 -0.089178,0.766172l25.9515 29.8537 12.9395 0c0.72329,0 1.49667,0.617795 1.3149,1.3149l-0.851934 3.26733c-0.181392,0.696727 -0.594646,1.31376 -1.3149,1.3149l-95.5711 0.161659c-0.720254,0.00113844 -1.13275,-0.615138 -1.3149,-1.3149l-0.893298 -3.42861c-0.182151,-0.699762 0.59161,-1.3149 1.3149,-1.3149l-0.000379481 -0.000379481zm1.90006 8.15125l93.5219 0c0.72329,0 1.49136,0.617036 1.3149,1.31528l-10.9621 43.3974c-0.176079,0.697865 -0.595785,1.31528 -1.3149,1.31528l-71.597 0c-0.719495,0 -1.13806,-0.61362 -1.3149,-1.31528l-10.9628 -43.3974c-0.177217,-0.70166 0.59161,-1.31528 1.3149,-1.31528zm46.7608 8.54818l0.000379481 0c0.72329,0 1.3149,0.59161 1.3149,1.3149l0 26.3018c0,0.72329 -0.59161,1.3149 -1.3149,1.3149l-0.000379481 0c-0.72329,0 -1.3149,-0.59161 -1.3149,-1.3149l0 -26.3018c0,-0.72329 0.59161,-1.3149 1.3149,-1.3149zm-13.1536 0l0.000379481 0c0.72329,0 1.3149,0.59161 1.3149,1.3149l0 26.3018c0,0.72329 -0.59161,1.3149 -1.3149,1.3149l-0.000379481 0c-0.72329,0 -1.3149,-0.59161 -1.3149,-1.3149l0 -26.3018c0,-0.72329 0.59161,-1.3149 1.3149,-1.3149zm-13.1509 0l0.000379481 0c0.72329,0 1.3149,0.59161 1.3149,1.3149l0 26.3018c0,0.72329 -0.59161,1.3149 -1.3149,1.3149l-0.000379481 0c-0.72329,0 -1.3149,-0.59161 -1.3149,-1.3149l0 -26.3018c0,-0.72329 0.59161,-1.3149 1.3149,-1.3149zm39.4527 0l0.000379481 0c0.72329,0 1.3149,0.59161 1.3149,1.3149l0 26.3018c0,0.72329 -0.59161,1.3149 -1.3149,1.3149l-0.000379481 0c-0.72329,0 -1.3149,-0.59161 -1.3149,-1.3149l0 -26.3018c0,-0.72329 0.59161,-1.3149 1.3149,-1.3149zm13.1509 0l0.000379481 0c0.72329,0 1.3149,0.59161 1.3149,1.3149l0 26.3018c0,0.72329 -0.59161,1.3149 -1.3149,1.3149l-0.000379481 0c-0.72329,0 -1.3149,-0.59161 -1.3149,-1.3149l0 -26.3018c0,-0.72329 0.59161,-1.3149 1.3149,-1.3149z"></path></g></svg>
    </div>
    <h2 class="wph-mt-6 wph-mb-2 wph-text-xl">Корзина пуста</h2>
    <p class="wph-mb-2 wph-text-gray-700">Вы еще ничего не добавили в корзину</p>
    <p class="wph-mt-8"><button role="button" class="wph-button" @click="$emit('go-to-editor')"><svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="wph-inline-block wph-w-6 wph-h-6"><path d="M15 19l-7-7 7-7"></path></svg><span class="wph-align-middle">Вернуться к покупкам</span></button></p>
  </div>
</div>
</template>

<script>
import { mapMutations } from 'vuex'

import CartItem from './CartItem'
import PrintLocation from './PrintLocation'
import AppCheckbox from './Checkbox'
import Multiselect from 'vue-multiselect'

export default {
  name: "OrderSummary",
  components: {
    CartItem,
    PrintLocation,
    AppCheckbox,
    Multiselect,
  },
  props: {
    cartHasBags: { type: Boolean, required: true },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
    }
  },
  computed: {
    cartItems() {
      return this.$store.state.cart.items
    },
    cartItemsWithModels() {
      return this.cartItems.filter((item) => item.model)
    },
    orderIsUrgent: {
      get() {
        return this.$store.state.order.isUrgent
      },
      set(value) {
        this.$store.commit('setUrgency', value)
      },
    },
    orderUrgencyRate: {
      get() {
        return this.$store.state.order.urgencyRate
      },
      set(value) {
        this.$store.commit('setUrgencyRate', value)
      },
    },
    orderUrgencyRates() {
      return this.$store.state.order.urgencyRates
    },
  },
  methods: {
    ...mapMutations([
      'removeCartItemById',
      'editCartItem',
    ]),
    goToEditor(cartItem) {
      this.editCartItem(cartItem)
      this.$emit('go-to-editor')
    },
  },
}
</script>